var React = require('react');

function VideoControlsMuteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 7.82574V16.2225H11.2601L17.1475 21V3L11.2601 7.82574H6Z","fill":"currentColor"}));
}

VideoControlsMuteInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = VideoControlsMuteInline;

VideoControlsMuteInline.default = VideoControlsMuteInline;
